import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetCreditLimits } from '../../../credit/store/thunk/setGetCreditLimits';
import { setGetCreditLive } from '../../../credit/store/thunk/setGetCreditLive';
import { setGetInformationUsers } from '../../store/thunk/setGetInformationUsers';
import { setGetCountOnline } from '../../store/thunk/setGetCountOnline';
import { setGetDetalization } from '../../store/thunk/setGetDetalization';
import Credit from '../../components/credit';
import PanelItem from '../../components/panelItem';
import DatePicker from '../../../components/datePicker';
import moment from 'moment';
import { Allow as AllowMap } from '../../../../settings/allow';

const InformationPanel = () => {
    const dispatch = useDispatch();
    const utc = moment.utc().valueOf();

    React.useEffect(() => {
        dispatch(setGetCreditLimits());
        dispatch(setGetCreditLive());
        dispatch(setGetInformationUsers({
            date_from: 0,
            date_to: utc
        }));
        dispatch(setGetCountOnline())
    }, []);

    const credit = useSelector(state => state.creditMobile.list);
    const creditLive = useSelector(state => state.creditMobile.live);
    const count_users = useSelector(state => state.informationMobile.users);
    const count_new_users = useSelector(state => state.informationMobile.new_users);
    const users_online = useSelector(state => state.informationMobile.count_online);
    const view = useSelector(state => state.auth.admin);
    const Allow = AllowMap();

    return (
        <div style={{padding: 10}}>
            {
                view?.allow?.includes(Allow.CreditLine.allow) &&  <Credit slot={credit} live={creditLive} />
            }
            <PanelItem 
                label="Детализация пользователей" 
                labelCol={['Всего', 'Новые', 'Онлайн']}
                valueCol={[+count_users, +count_new_users, +users_online.count]}
            />
        </div>
    )
}

export default InformationPanel;